import {ProfileMenuContent} from '@/layout/Page/ProfileMenuContent';
import {MemberAvatar} from '@/components/styled/MemberAvatar';
import {
  TAB_TITLE_MAP,
  useMobileNavigation,
} from '@/contexts/MobileNavigationContext/MobileNavigationContext';
import {Box, Drawer, IconButton, Typography} from '@mui/material';
import {tokens, userProfileContext} from '@ark/web';
import {useTheme} from '@mui/material/styles';
import {useContext, useState} from 'react';

const HEADER_HEIGHT = 56;

export {HEADER_HEIGHT};

export const MobileHeader = () => {
  const theme = useTheme();
  const {activeTab} = useMobileNavigation();
  const {firstName, lastName, displayPicture} = useContext(userProfileContext);
  const [profileOpen, setProfileOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          minHeight: `${HEADER_HEIGHT}px`,
          height: `calc(${HEADER_HEIGHT}px + env(safe-area-inset-top))`,
          paddingTop: 'env(safe-area-inset-top)',
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
          display: 'flex',
          alignItems: 'center',
          px: 1,
          gap: 0.5,
          zIndex: 1200,
          transition: `background-color ${tokens.transition.normal}`,
        }}
      >
        <Typography
          sx={{
            fontSize: 17,
            fontWeight: 700,
            color: theme.palette.text.primary,
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            pl: 1,
          }}
        >
          {TAB_TITLE_MAP[activeTab]}
        </Typography>
        <IconButton
          onClick={() => setProfileOpen(true)}
          size="small"
          sx={{ml: 0.5}}
        >
          <MemberAvatar
            displayPicture={displayPicture ?? undefined}
            name={`${firstName} ${lastName}`}
            size={32}
          />
        </IconButton>
      </Box>
      <Drawer
        anchor="bottom"
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: '80vh',
            pb: 'env(safe-area-inset-bottom)',
          },
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            backgroundColor: theme.palette.action.disabled,
            mx: 'auto',
            mt: 1.5,
            mb: 1,
          }}
        />
        <ProfileMenuContent onSelect={() => setProfileOpen(false)} />
      </Drawer>
    </>
  );
};
